import { BASE_URL } from '../../constants/baseUrl';
import axiosInstance from '../../utils/axiosInstance';

class FinanceService {
  fetchRefunds = (search = '') => {
    let url = `${BASE_URL}/v1/finance/refunds`;
    if (search) {
      url += `?search=${encodeURIComponent(search)}`;
    }
    return axiosInstance.get(url);
  };

  fetchPayouts = (search = '') => {
    let url = `${BASE_URL}/v1/finance/payouts`;
    if (search) {
      url += `?search=${encodeURIComponent(search)}`;
    }
    return axiosInstance.get(url);
  };
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new FinanceService();
